/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDUturnUpRightIcon16Light } from './ArrowDUturnUpRightIcon16Light';
import { ArrowDUturnUpRightIcon16Regular } from './ArrowDUturnUpRightIcon16Regular';
import { ArrowDUturnUpRightIcon16Solid } from './ArrowDUturnUpRightIcon16Solid';
import { ArrowDUturnUpRightIcon20Light } from './ArrowDUturnUpRightIcon20Light';
import { ArrowDUturnUpRightIcon20Regular } from './ArrowDUturnUpRightIcon20Regular';
import { ArrowDUturnUpRightIcon20Solid } from './ArrowDUturnUpRightIcon20Solid';
import { ArrowDUturnUpRightIcon24Regular } from './ArrowDUturnUpRightIcon24Regular';
import { ArrowDUturnUpRightIcon24Solid } from './ArrowDUturnUpRightIcon24Solid';
import { ArrowDUturnUpRightIcon32Regular } from './ArrowDUturnUpRightIcon32Regular';
import { ArrowDUturnUpRightIcon64Regular } from './ArrowDUturnUpRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDUturnUpRightIcon16Light,
        regular: ArrowDUturnUpRightIcon16Regular,
        solid: ArrowDUturnUpRightIcon16Solid,
    },
    20: {
        light: ArrowDUturnUpRightIcon20Light,
        regular: ArrowDUturnUpRightIcon20Regular,
        solid: ArrowDUturnUpRightIcon20Solid,
    },
    24: {
        regular: ArrowDUturnUpRightIcon24Regular,
        solid: ArrowDUturnUpRightIcon24Solid,
    },
    32: {
        regular: ArrowDUturnUpRightIcon32Regular,
    },
    64: {
        regular: ArrowDUturnUpRightIcon64Regular,
    },
};
export var ArrowDUturnUpRightIcon = forwardRef('ArrowDUturnUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
